import { genMessage } from '../helper';
// import elementPlus from 'element-plus/dist/locale/id.mjs';
// 修改文件

const modules = import.meta.glob('./id/*.ts', { eager: true });

export default {
	message: {
		...genMessage(modules, 'id'),
	},
	// dateLocale: elementPlus,
	dateLocaleName: 'Id',
};
